import React, { useCallback, useContext, useMemo, useState } from 'react';
import { addNewCommentEditor } from '../../features/editior/editorSlice';
import { useDispatch } from 'react-redux';

const defaultContext = { subject: null, position: { from: 0, to: 0 }, onSuccess: () => {} };

export const ThreadContext = React.createContext({
  newThread: defaultContext,
  addNewThread: () => {},
  setNewThread: () => {},
  registerThread: () => {},
  resolveThread: () => {},
});

export const useThreadProvider = () => {
  const values = useContext(ThreadContext);
  if (!values) return defaultContext;

  return values;
};

export const ThreadProvider = ({ children }) => {
  const dispatch = useDispatch();
  const [newThread, setNewThread] = useState(defaultContext);

  const registerThread = useCallback(
    ({ subject, position, onSuccess }) => {
      setNewThread({ subject, position, onSuccess });
    },
    [setNewThread]
  );

  const addNewThread = useCallback(
    ({ subject, content, startPos, endPos, fileId, workspaceId }) => {
      const body = { selected_text: subject, comment: content, start_pos: startPos, end_pos: endPos };
      dispatch(addNewCommentEditor({ body, fileId, workspaceId })).then(({ payload }) => {
        const { onSuccess } = newThread;
        if (payload && payload?.data) {
          onSuccess(payload?.data?.id);
          setNewThread(defaultContext);
        }
      });
    },
    [dispatch, newThread]
  );

  const resolveThread = useCallback(() => setNewThread(defaultContext), [setNewThread]);

  const values = useMemo(
    () => ({ newThread, setNewThread, registerThread, resolveThread, addNewThread }),
    [newThread, setNewThread, registerThread, resolveThread, addNewThread]
  );

  return <ThreadContext.Provider value={values}>{children}</ThreadContext.Provider>;
};
